import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentLoader from 'react-content-loader';

// Sizes mirror `hotelDealsRm3.scss` (photo height, radii, Book button) so the skeleton has the room's shape.
const PHOTO_HEIGHT = 160;
const PHOTO_RADIUS = 12;
const TITLE_HEIGHT = 26;
const LINE_HEIGHT = 16;
const CHIP_HEIGHT = 24;
const CHIP_RADIUS = 4;
const AMOUNT_WIDTH = 96;
const AMOUNT_HEIGHT = 26;
const SUBLINE_WIDTH = 140;
const BOOK_WIDTH = 90;
const BOOK_HEIGHT = 41;
const BOOK_RADIUS = 8;
const LINE_RADIUS = 8;
const SPEC_WIDTHS = [56, 64, 72];
const CHIP_WIDTHS = [128, 104, 148, 96];
const MORE_DETAILS_WIDTH = 88;
const DEAL_ROWS = 3;

function Block({ width, height, radius = LINE_RADIUS, isRtl }) {
    return (
        <ContentLoader width={width} height={height} rtl={isRtl} title="" aria-hidden="true">
            <rect x="0" y="0" rx={radius} ry={radius} width="100%" height={height} />
        </ContentLoader>
    );
}

/** Loading placeholder in the shape of `Rm3RoomContainer`: room panel left, three deal rows right. */
function Rm3RoomSkeleton({ isRtl }) {
    const { t } = useTranslation();
    return (
        <div
            className="rm3-room rm3-room-skeleton"
            data-testid="rm3-room-skeleton"
            aria-busy="true"
            aria-label={t('Loading')}
        >
            <div className="rm3-room__panel">
                <Block width="100%" height={PHOTO_HEIGHT} radius={PHOTO_RADIUS} isRtl={isRtl} />
                <div className="rm3-room__info">
                    <div className="rm3-room__heading">
                        <Block width="70%" height={TITLE_HEIGHT} isRtl={isRtl} />
                        <div className="rm3-specs">
                            {SPEC_WIDTHS.map((width) => (
                                <Block key={width} width={width} height={LINE_HEIGHT} isRtl={isRtl} />
                            ))}
                        </div>
                    </div>
                    <div className="rm3-room__amenities">
                        {CHIP_WIDTHS.map((width) => (
                            <Block key={width} width={width} height={CHIP_HEIGHT} radius={CHIP_RADIUS} isRtl={isRtl} />
                        ))}
                        <Block width={MORE_DETAILS_WIDTH} height={LINE_HEIGHT} isRtl={isRtl} />
                    </div>
                </div>
            </div>
            <div className="rm3-room__deals">
                <div className="rm3-card__deals">
                    {Array.from({ length: DEAL_ROWS }).map((_, index) => (
                        <div className="rm3-deal" key={index}>
                            <div className="rm3-deal__terms">
                                <Block width="70%" height={LINE_HEIGHT} isRtl={isRtl} />
                                <Block width="45%" height={LINE_HEIGHT} isRtl={isRtl} />
                            </div>
                            <div className="rm3-deal__price rm3-room-skeleton__price">
                                <div className="rm3-room-skeleton__amount">
                                    <Block width={AMOUNT_WIDTH} height={AMOUNT_HEIGHT} isRtl={isRtl} />
                                    <Block width={SUBLINE_WIDTH} height={LINE_HEIGHT} isRtl={isRtl} />
                                </div>
                                <Block width={BOOK_WIDTH} height={BOOK_HEIGHT} radius={BOOK_RADIUS} isRtl={isRtl} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Rm3RoomSkeleton;
